export type IAccountStatus = 'active' | 'inactive';
export type INotificationType = 'Email' | 'Email & SMS' | 'SMS';
export type IDeliveryType = 'Paper' | 'Electronic' | 'Both';
export type ILoanType = 'Paper' | 'Both';
export type IEnrollmentStatus = 'Enrolled';

export interface AccountManagementRes {
  id: string;
  accountNumber: string;
  accountType: string;
  accountName: string;
  subRows: AccountManagementSubRow[];
  status: IAccountStatus;
}

export interface AccountManagementSubRow {
  id: string;
  cif: string;
  name: string;
  email: string;
  status: IAccountStatus;
  ssoEnrollDate: string;
  dsoEnrollDate: string;
  loan: ILoanType;
  lastLogin: string;
  failedLoginCounter: string;
  enrollmentStatus: IEnrollmentStatus;
  checkingStatement: IDeliveryType;
  eTax: IDeliveryType;
  visa: IDeliveryType;
  mortgage: IDeliveryType;
  notices: IDeliveryType;
  notification: INotificationType;
  phone: string;
}

export interface IAccountManagementCol {
  id: string;
  enableSorting: boolean;
  name: string;
}

const accountManagementCol: IAccountManagementCol[] = [
  {
    id: '1',
    enableSorting: true,
    name: 'Account Number',
  },
  {
    id: '2',
    enableSorting: true,
    name: 'Account Type',
  },
  {
    id: '3',
    enableSorting: true,
    name: 'Account Name',
  },
];

export interface IAccountManagementSubCol {
  id: string;
  name: string;
}

export const accountManagementSubCol: IAccountManagementSubCol[] = [
  {
    id: '1',
    name: 'cif',
  },
  {
    id: '2',
    name: 'name',
  },
  {
    id: '3',
    name: 'email',
  },
];

export default accountManagementCol;
